export default class FitVideo {
    constructor() {
        this.init();
    }

    init() {
        if (document.querySelector(".js-fitvideo")) {
            this.setFSMovie();
            this.eventBind();
        }
    }

    eventBind() {
        //背景ビデオのフィットとデバイス置換
        window.addEventListener("resize", this.setFSMovie);
    }

    setFSMovie() {
        const hdratio = 990 / 1920;
        const ratio = window.innerHeight / window.innerWidth;
        const $video = document.querySelectorAll(".js-fitvideo");

        $video.forEach(($el) => {
            //縦フィットしないといけない場合
            if (ratio > hdratio) {
                $el.classList.add("-fit_y");
            } else {
                $el.classList.remove("-fit_y");
            }
        });
    }
}
